//local
//export const api_raiz = "http://localhost:8000/";

//qa
//export const api_raiz = "https://one.skynavieros.com:8080/skyone_qa/";

//Mexico QA
//export const api_raiz = "https://qa-one-back.skyangel.com.mx/skyone2/"

// PatiosBot
export const api_bot =  "https://skyiapatios.skyangel.com.mx";

// Produccion
export const socket = "https://socket.skyangel.com.mx:8443/mensajeria_skyone/";
export const api_raiz = "https://one.skynavieros.com:8080/skyone/";
//export const api_raiz= "https://monitoreo.skynavieros.com:8080/skyone/";

export const cctv = "https://cctv.skyangel.com.mx";
export const cctvToken = "";
//export const cctv= "http://localhost";
